import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Button, Icon, Modal, TransitionablePortal } from "semantic-ui-react";
import {
    RemoveAdditionalOutage,
    SetAdditionalOutage,
} from "../../../../../../actions/additionalOutageActions";
import { AppState } from "../../../../../../store/configureStore";

export const ViewSavedOutages = () => {
    const dispatch = useDispatch();
    const { additionalOutages } = useSelector((state: AppState) => state.additionalOutage);
    const [aoModalOpen, setAoModalOpen] = useState(false);
    const [clearModalOpen, setClearModalOpen] = useState(false);
    const availableTimestampsOrScenarios = useSelector((state: AppState) => state.validationProcess.availableTimestampsOrScenarios);

    const handleConfirm = () => {
        dispatch(SetAdditionalOutage([]));
        setClearModalOpen(false);
    };

    useEffect(() => {
        if (additionalOutages.length === 0) setAoModalOpen(false);
    }, [additionalOutages.length]);

    return (
        <>
            <CSSTransition
                id="CSSTransition-viewSavedOutages-a"
                in={additionalOutages.length > 0}
                timeout={400}
                classNames="neselector-transition"
                unmountOnExit
            >
                <div id="div-viewSavedOutages-a" className="saved-elements-actions">
                    <Button id="button-viewSavedOutages-close" icon="close" size="tiny" onClick={() => setClearModalOpen(true)} />
                    <Button
                        id="button-viewSavedOutages-viewSaved"
                        content="View saved additional outages"
                        size="tiny"
                        onClick={() => setAoModalOpen(true)}
                    />
                </div>
            </CSSTransition>
            <TransitionablePortal
                id="transitionablePortal-viewSavedOutages-a"
                open={aoModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-viewSavedOutages-a" onClose={() => setAoModalOpen(false)} open closeOnDimmerClick size="small">
                    <Modal.Header id="modalHeader-viewSavedOutages-savedAdditional">Saved additional outages</Modal.Header>
                    <Modal.Content id="modalContent-viewSavedOutages-a">
                        {additionalOutages.map(ao => (
                            <section id={`section-viewSavedOutages-b-${ao.branch.elementName}`} key={ao.branch.key} className="view-saved">
                                <div id={`div-viewSavedOutages-b-${ao.branch.elementName}`}>
                                    <h4 id={`h4-viewSavedOutages-b-${ao.branch.elementName}`}> {ao.branch.elementName}</h4>
                                    <p id={`p-viewSavedOutages-b-${ao.branch.elementName}`}>
                                        <span id={`span-viewSavedOutages-from-${ao.branch.elementName}`}>From: </span>
                                        {ao.branch.node1}
                                    </p>
                                    <p id={`p-viewSavedOutages-c-${ao.branch.elementName}`}>
                                        <span id={`span-viewSavedOutages-to-${ao.branch.elementName}`}>To: </span>
                                        {ao.branch.node2}
                                    </p>
                                    <p id={`p-viewSavedOutages-d-${ao.branch.elementName}`}>
                                        <span id={`span-viewSavedOutages-order-${ao.branch.elementName}`}>Order: </span>
                                        {ao.branch.orderCode}
                                    </p>
                                    <p id={`p-viewSavedOutages-e-${ao.branch.elementName}`}>
                                        <span id={`span-viewSavedOutages-elementName-${ao.branch.elementName}`}>Element name: </span>
                                        {ao.branch.elementName}
                                    </p>
                                    <p id={`p-viewSavedOutages-f-${ao.branch.elementName}`}>
                                        <span id={`span-viewSavedOutages-timestamps-${ao.branch.elementName}`}>Timestamps: </span>
                                        {ao.timestamps.map((ts, index) => (
                                            <label id={`label-viewSavedOutages-from-${ao.branch.elementName}-${index}`} key={ts}>
                                                {availableTimestampsOrScenarios.find(d => d.key === ts)?.text}
                                                &nbsp;
                                            </label>
                                        ))}
                                    </p>
                                </div>
                                <Icon
                                    id={`icon-viewSavedOutages-close-${ao.branch.elementName}`}
                                    name="close"
                                    size="large"
                                    link
                                    onClick={() => dispatch(RemoveAdditionalOutage(ao))}
                                />
                            </section>
                        ))}
                    </Modal.Content>
                </Modal>
            </TransitionablePortal>
            <TransitionablePortal
                id="transitionablePortal-viewSavedOutages-c"
                open={clearModalOpen}
                onOpen={() => setTimeout(() => document.body.classList.add("modal-fade-in"), 0)}
                transition={{ animation: "scale", duration: 300 }}
            >
                <Modal id="modal-clearAdditional-c" dimmer="inverted" size="mini" open onClose={() => setClearModalOpen(false)}>
                    <Modal.Header id="modalHeader-clearAdditional-c">
                        Are you sure you want to clear all additional outages?
                    </Modal.Header>
                    <Modal.Actions id="modalActions-viewSavedOutages-c">
                        <Button id="button-viewSavedOutages-no" content="No" onClick={() => setClearModalOpen(false)} />
                        <Button id="button-viewSavedOutages-yes" primary content="Yes" onClick={() => handleConfirm()} />
                    </Modal.Actions>
                </Modal>
            </TransitionablePortal>
        </>
    );
};
